// Valid MTO options (5 MTOs - MoneyGram removed)
export const VALID_MTOS = [
  'RIA Money Transfer',
  'IME (International Money Express)',
  'InstantCash',
  'Express Money',
  'Jingle Pay',
] as const

export type ValidMTO = (typeof VALID_MTOS)[number]

// Valid Sub-Agent options
export const VALID_SUB_AGENTS = [
  'Bank of Jammu & Kashmir',
  'Karakoram Cooperative Bank',
] as const

export type ValidSubAgent = (typeof VALID_SUB_AGENTS)[number]

// Helper function to validate MTO
export const isValidMTO = (mto: string): mto is ValidMTO => {
  return VALID_MTOS.includes(mto as ValidMTO)
}

// Helper function to validate Sub-Agent
export const isValidSubAgent = (
  subAgent: string,
): subAgent is ValidSubAgent => {
  return VALID_SUB_AGENTS.includes(subAgent as ValidSubAgent)
}

// Helper function to get nearest valid MTO (for migration/cleanup)
export const getNearestValidMTO = (mto: string): ValidMTO => {
  const lowerMTO = mto.toLowerCase()

  if (lowerMTO.includes('ria')) return 'RIA Money Transfer'
  if (lowerMTO.includes('ime') || lowerMTO.includes('international money'))
    return 'IME (International Money Express)'
  if (lowerMTO.includes('instant')) return 'InstantCash'
  if (lowerMTO.includes('express')) return 'Express Money'
  if (lowerMTO.includes('jingle')) return 'Jingle Pay'

  // Default to first option if no match
  return VALID_MTOS[0]
}

// Helper function to get nearest valid Sub-Agent (for migration/cleanup)
export const getNearestValidSubAgent = (subAgent: string): ValidSubAgent => {
  const lowerSubAgent = subAgent.toLowerCase()

  if (
    lowerSubAgent.includes('jammu') ||
    lowerSubAgent.includes('kashmir') ||
    lowerSubAgent.includes('j&k')
  ) {
    return 'Bank of Jammu & Kashmir'
  }
  if (
    lowerSubAgent.includes('karakoram') ||
    lowerSubAgent.includes('cooperative')
  ) {
    return 'Karakoram Cooperative Bank'
  }

  // Default to first option if no match
  return VALID_SUB_AGENTS[0]
}
